import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * Shared width for list / table / board pages: centered, capped at ~1536px so dense tables breathe
 * without spanning edge-to-edge (and forcing a long Item→Actions eye-scan) on ultrawide monitors.
 * Single source of truth — use the `PageContainer` component, or compose this class with `cn(...)` on
 * a page's existing outer element. Forms, detail cards, and print/auth pages keep their own narrower caps.
 */
export const PAGE_CONTAINER_CLASS = 'mx-auto w-full max-w-[1536px]';

/** Wrapper form of {@link PAGE_CONTAINER_CLASS}. Pass page spacing (e.g. `space-y-6`) via `className`. */
export function PageContainer({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={cn(PAGE_CONTAINER_CLASS, className)}>{children}</div>;
}
